/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/survey-api';
}

/**
 * Parameters for `SurveyApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
